import { compose } from 'redux';
import { connect } from 'react-redux';
import { Size } from '../../../constants/components';
import { RCT, ACCURACY } from '../../../constants/measure';
import { SHORT_WORD_LENGTH } from '../../../constants/text';
import { QUESTIONS } from '../../../constants/assessmentItemType';
import WR_AUDIO_INSTRUCTIONS from '../../wrConstants';
import selectors from '../../../rootSelectors';
import { getQuestionIndex } from '../../../common/utils/urlParsers';
import { fetchWRContent, continueWRAssessment } from '../../wrActions';
import MultiChoiceQuestionView from '../../../common/questions/multiChoiceQuestionView';
import * as multiChoiceUtils from '../../../common/questions/multiChoiceQuestionUtils';
import AvatarView from '../../../common/avatar/avatarView';
import withAvatar from '../../../common/avatar/withAvatar';
import { getAvatarPosition } from '../../../common/alex/AlexUtils';

const mapStateToProps = (state, ownProps) => {
    const questionIndex = getQuestionIndex(ownProps.match.params);
    return {
        ...multiChoiceUtils.mapStateToProps(state),
        // TODO so far let it be RCT layout
        pageLayout: `${RCT}-${ACCURACY}`,
        isDataFetched: selectors.getIsWRDataFetched(state),
        fontSize: selectors.getWRMaxResponseLength(state, QUESTIONS) > SHORT_WORD_LENGTH
            ? Size.SMALL : Size.LARGE,
        possibleResponses: selectors.getWRPossibleResponses(
            state, QUESTIONS, questionIndex - 1,
        ),
        stimulusAudio: selectors.getWRStimulusAudio(state, QUESTIONS, questionIndex - 1),
        questionIndex,
    };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
    ...multiChoiceUtils.mapDispatchToProps(dispatch),
    onNext: () => dispatch(continueWRAssessment(getQuestionIndex(ownProps.match.params))),
    fetchContent: () => dispatch(fetchWRContent()),
});

const avatarMapStateToProps = () => {
    const positionConfig = {
        alyxPosition: AvatarView.Position.TOP_HEADER_CENTER,
        defaultViewPosition: AvatarView.Position.LOWER_LEFT
    };
    const position = getAvatarPosition(positionConfig);
    return {
        position,
        animateAlex: true,
        instructions: WR_AUDIO_INSTRUCTIONS.wrQuestionsInstruction,
    };
};

const WRQuestionsContainer = compose(
    connect(mapStateToProps, mapDispatchToProps),
    withAvatar(avatarMapStateToProps),
)(MultiChoiceQuestionView);

export default WRQuestionsContainer;
